var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from 'aurelia-dependency-injection';
import { BaseWidget } from './base-widget';
import { transient } from 'aurelia-dependency-injection';
import { EntityTypeConfigurationHelper } from '../models/basics/basics.models';
import { QueryFilterUriConverter } from '../views/components/converters/queries/query-filter';
import { InitFilterValueConverter } from '../views/components/converters/queries/init-filter';
import { QueriesClientService } from '../services/queries/queries-client.services';
import { CacheClient, CacheKeys, CacheLocation } from "../services/basics/client-caching.service";
import { SignalClientService } from "../services/basics/signal-client.service";
import { computedFrom } from "aurelia-binding";
import { Reflection } from "../utilities/reflection";
import { DialogServiceConstants } from "../constants/basics/dialog.constants";
import { DialogClientService } from "../services/basics/dialog-client.service";
var GaugeWidget = /** @class */ (function (_super) {
    __extends(GaugeWidget, _super);
    function GaugeWidget(entityTypeConfigurationHelper, initFilter, queriesService, cache, signalClientService, dialogClientService) {
        var _this = _super.call(this, signalClientService) || this;
        _this.entityTypeConfigurationHelper = entityTypeConfigurationHelper;
        _this.initFilter = initFilter;
        _this.queriesService = queriesService;
        _this.cache = cache;
        _this.dialogClientService = dialogClientService;
        _this.entityTypes = _this.entityTypeConfigurationHelper.getConfiguration([]);
        _this.isLoading = true;
        return _this;
    }
    Object.defineProperty(GaugeWidget.prototype, "target", {
        get: function () {
            return this.model && this.model.target ? this.model.target.toLocaleString() : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GaugeWidget.prototype, "count", {
        get: function () {
            if (!this._count)
                return 0;
            return this._count % 1 !== 0 ? this._count.toFixed(2) : this._count;
        },
        enumerable: false,
        configurable: true
    });
    GaugeWidget.prototype.onActivate = function (model) {
        this.title = model.title;
        this.description = model.description;
        this.model = model;
        this.selectedFilters = model.queryFilters;
        this.refreshData();
    };
    GaugeWidget.prototype.getCount = function (selectedModel, selectedFilters) {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            var uri = 'odata/' + selectedModel;
            var converter = new QueryFilterUriConverter(_this.initFilter, selectedFilters, 0, 0, []);
            uri += converter.getUri(true);
            uri += '&$count=true&$top=0';
            _this.queriesService.getData(uri)
                .then(function (res) {
                var count = res['@odata.count'];
                resolve(count);
            }).catch(function (error) {
                reject(error);
            });
        });
        return promise;
    };
    GaugeWidget.prototype.getSum = function (selectedModel, selectedFilters, aggrigationProperty) {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            var uri = 'odata/' + selectedModel;
            uri += "/Genesis.GroupBy(column=null,propertyForAggregation='" + aggrigationProperty.name + "',aggregationType='sum')";
            var converter = new QueryFilterUriConverter(_this.initFilter, selectedFilters, 0, 0, []);
            uri += converter.getUri(true);
            _this.queriesService.getData(uri)
                .then(function (res) {
                var sumValue = res && res.value && res.value.length > 0 && res.value[0] && res.value[0].sum ? res.value[0].sum : 0;
                resolve(sumValue);
            }).catch(function (error) {
                reject(error);
            });
        });
        return promise;
    };
    GaugeWidget.prototype.view = function () {
        this.cache.put(CacheKeys.selectedFilters, {
            queryFilters: this.model.queryFilters,
            columns: this.model.columns
        }, CacheLocation.SessionStorage);
        this.dialogClientService.show(DialogServiceConstants.URLs.ViewQueryDialog, { uri: this.model.entityTypeUri, title: this.title }, true, true);
    };
    GaugeWidget.prototype.refreshData = function () {
        var _this = this;
        this.isLoading = true;
        this.getCurrentCount()
            .then(function (count) {
            _this._count = count || 0;
            var percentage = 0;
            if (_this._count !== 0) {
                percentage = count / _this.model.target * 100;
            }
            _this.value = percentage;
            _this.isLoading = false;
        })
            .catch(function (err) {
            _this.value = 0;
        });
    };
    GaugeWidget.prototype.getCurrentCount = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.model.aggrigationProperty && _this.model.aggrigationProperty.name.trim() != "") {
                _this.getSum(_this.model.entityTypeUri, _this.model.queryFilters, _this.model.aggrigationProperty).then(function (sum) {
                    resolve(sum);
                }).catch(function (e) {
                    reject(e);
                });
            }
            else {
                _this.getCount(_this.model.entityTypeUri, _this.model.queryFilters)
                    .then(function (count) {
                    resolve(count);
                })
                    .catch(function (err) {
                    reject(err);
                });
            }
        });
    };
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.model; })),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], GaugeWidget.prototype, "target", null);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x._count; })),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], GaugeWidget.prototype, "count", null);
    GaugeWidget = __decorate([
        transient(),
        autoinject(),
        __metadata("design:paramtypes", [EntityTypeConfigurationHelper,
            InitFilterValueConverter,
            QueriesClientService,
            CacheClient,
            SignalClientService,
            DialogClientService])
    ], GaugeWidget);
    return GaugeWidget;
}(BaseWidget));
export { GaugeWidget };
